import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { TiPlus } from "react-icons/ti";

import AddExercise from "./Modals/AddExercise";
import FilledButton from "components/InterstellrComponents/FilledButton";
import ExerciseCategory from "./ExerciseCategory";
import { generateURLOptions } from "URLOptions";

import {
  CREATE_EXERCISE,
  DELETE_EXERCISE,
  GET_EXERCISES,
  UPDATE_EXERCISE_AVAILABILITY,
} from "URLRoutes";
import EditExercise from "./Modals/EditExercise";

const Exercises = () => {
  const [exercises, setExercises] = useState([]);
  const [showAddExercise, setShowAddExercise] = useState(false);

  const [selectedExercise, setSelectedExercise] = useState(null);
  const [showEditExercise, setShowEditExercise] = useState(false);

  useEffect(() => {
    document.title = "Exercise Editor | Administration Panel | Mind Pulse";
    getExercises();
  }, []);

  const getExercises = async () => {
    try {
      const response = await axios.get(GET_EXERCISES, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      setExercises(response?.data?.data);
    } catch (error) {
      console.error("Get Exercises Error:", error);
      alert(error);
    }
  };

  const addExercise = async (data) => {
    try {
      const response = await axios.post(CREATE_EXERCISE, data, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      setShowAddExercise(false);
      getExercises();
    } catch (error) {
      console.error("Create Exercises Error:", error);
      alert(error);
    }
  };

  const updateExerciseAvailability = async (data) => {
    try {
      const response = await axios.post(UPDATE_EXERCISE_AVAILABILITY, data, {
        headers: generateURLOptions(),
      });
      if (response?.data?.success === false) {
        return alert(response?.data?.message ?? "");
      }
      getExercises();
    } catch (error) {
      console.error("Update Exercise Availability Error:", error);
      alert(error);
    }
  };

  const deleteExercise = async (id) => {
    Swal.fire({
      title: "Delete Exercise Routine",
      text: "Deleting an Exercise Routine is irreversible. Please confirm you want to delete this item.",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete Exercise Routine",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            DELETE_EXERCISE,
            { itemId: id },
            { headers: generateURLOptions() }
          );
          if (response?.data?.success === false) {
            return alert(response?.data?.message ?? "");
          }
          getExercises();
        } catch (error) {
          console.error("Delete Exercises Error:", error);
          alert(error);
        }
      }
    });
  };

  const totalExercises = exercises?.reduce(
    (acc, type) => acc + (type?.exercises ? type.exercises.length : 0),
    0
  );

  return (
    <>
      <AddExercise
        isOpen={showAddExercise}
        onClose={() => setShowAddExercise(false)}
        onSubmit={addExercise}
      />

      <EditExercise
        isOpen={showEditExercise}
        onClose={() => {
          setShowEditExercise(false);
          getExercises();
        }}
        item={selectedExercise}
      />

      <div className="w-full px-8">
        {/* Heading */}
        <div className="flex flex-row mt-8">
          <div className="flex flex-col">
            <h4 className="font-medium text-lg">Exercise Routines</h4>
            <p className="font-light text-base">
              {exercises?.length} Categories, {totalExercises} Exercises
            </p>
          </div>
          <div className="flex-1" />
          <div className="w-1/6">
            <FilledButton
              text="Add"
              icon={<TiPlus className="text-white mr-2" />}
              onPress={() => setShowAddExercise(true)}
              borderRadius={96}
            />
          </div>
        </div>

        {/* Categories */}
        {exercises?.map((category) => (
          <ExerciseCategory
            key={category._id}
            category={category}
            setExercises={setExercises}
            deleteExercise={deleteExercise}
            onEditExercise={(data) => {
              setSelectedExercise(data);
              setShowEditExercise(true);
            }}
            updateExerciseAvailability={updateExerciseAvailability}
          />
        ))}
      </div>
    </>
  );
};

export default Exercises;
